import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import type { ApiServerEntityIDType } from '../../../types';
import { ClientType } from '../clientType';
import { ClientPhotoViewModel } from '../photo/view';
import { ClientAudioViewModel } from '../audio/view';
import { ModerationViewModel } from '../../moderation/moderationViewModel';
import { ClientPatronageStage } from '../../admin/clientPatronage/stage';
import { CityViewModel } from '../../location/cityViewModel';
import { ClientInterviewViewModel } from '../../admin/clientInterview/view';
import { PromocodeViewModel } from '../../billing/promocode/view';
import { Sex } from './sex';
import type { IClientMarkers } from './clientProfileMarkers.dto';

export class ClientProfileViewModel {
  @Expose()
  @ApiProperty()
  id: ApiServerEntityIDType;

  @Expose()
  @ApiProperty({ required: false })
  name?: string;

  @Expose()
  @ApiProperty({ required: false })
  surname?: string;

  @Expose()
  @ApiProperty({ required: false })
  patronymic?: string;

  @Expose()
  @ApiProperty({ required: false })
  age?: number;

  @Expose()
  @ApiProperty({ required: false })
  mainPhoto?: ClientPhotoViewModel;

  @Expose()
  @ApiProperty({ required: false })
  photoSet?: ClientPhotoViewModel[];

  @Expose()
  @ApiProperty({ required: false })
  mainCareerId?: ApiServerEntityIDType;

  @Expose()
  @ApiProperty({ required: false })
  mainResumeId?: ApiServerEntityIDType;

  @Expose()
  @ApiProperty()
  mainResumeIsPublished?: boolean;

  @Expose()
  @ApiProperty({ required: false })
  type?: ClientType;

  @Expose()
  @ApiProperty({ required: false })
  cityId?: ApiServerEntityIDType;

  @ApiProperty({ required: false })
  @Expose()
  city?: CityViewModel;

  @Expose()
  @ApiProperty({ required: false })
  phone?: string;

  @Expose()
  @ApiProperty({ required: false })
  email?: string;

  @Expose()
  @ApiProperty({ required: false })
  sex?: Sex;

  @Expose()
  @ApiProperty({ required: false })
  birthDate?: string;

  @Expose()
  @ApiProperty({ required: false })
  address?: string;

  @Expose()
  @ApiProperty({ required: false })
  location?: string;

  @ApiProperty({ required: false, enum: ClientPatronageStage, enumName: 'ClientPatronageStage' })
  patronageStage?: ClientPatronageStage;

  @ApiProperty({ type: ModerationViewModel })
  /**
   * @deprecated
   */
  moderation: ModerationViewModel;

  @Expose()
  @ApiProperty()
  isWorking: boolean;

  @Expose()
  @ApiProperty()
  isDocumentsChecked: boolean;

  @ApiProperty()
  interview?: ClientInterviewViewModel;

  @Expose()
  @ApiProperty()
  createdAt: string;

  @Expose()
  @ApiProperty({ required: false })
  trainingCompletedAt?: string;

  @Expose()
  @ApiProperty({ required: false })
  personalQualitiesCompletedAt?: string;

  @Expose()
  @ApiProperty()
  hasAudio: boolean;

  @Expose()
  @ApiProperty({ type: [ClientAudioViewModel], required: false })
  audio?: ClientAudioViewModel[];

  @ApiProperty()
  personalPromocode?: PromocodeViewModel;

  @Expose()
  @ApiProperty({ required: true, example: { viewiedRulesForWorking: false } })
  markers: IClientMarkers;
}
